<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col-12 space">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1">
              <router-link  to="/">{{$t("addAd.breadcrumb_1")}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="mx-1 breadcrumb-title">
              <router-link to="/propertiecreate">
                {{$t("nav.realEstateServices")}}
              </router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-2 almarai-bold" aria-current="page">
              {{$t("addAd.breadcrumb_3")}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row justify-content-center pt-3" v-if="step == 1">
      <div class="col-12 text-center">
        <div>
          <img src="/assets/images/businessproject-img.png" class="width-140" alt="">
        </div>
        <p class="pt-2 mb-0 orange-font">{{$t('addAd.businessTransfer_P1')}}</p>
        <p class="font-24 almarai-bold mb-0">{{$t('addAd.businessTransfer_P2')}}</p>
        <p class="gray-50">{{$t('addAd.businessTransfer_P3')}}<br>{{$t('addAd.businessTransfer_P4')}}</p>
      </div>
      <div class="col-9 col-md-4 pt-3 text-center mouse-hand">
        <div class="btn-green" @click="nextStep">{{$t('addAd.businessTransfer_button')}}</div>
      </div>
    </div>
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <div class="row" v-if="step == 2">
      <mainloader v-if="isLoading" />
      <div v-else class="col">
        <div class="row justify-content-center">
          <div class="col-12 col-md-8">
            <div class="card border-0">
              <div class="card-body">
                <form action="">
                  <h6 class="almarai-bold">{{$t('addAd.businessTransfer_h6')}}</h6>
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.businessTransfer_name')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="name" :placeholder="$t('addAd.name_placeholder')" class="form-control input-style"
                        maxlength="50" @keypress="charsOnly"
                      >
                      <div class="error-feedback red-color fonttext-14" v-if="validate.name.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.businessTransfer_mobile')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="mobile" :placeholder="$t('addAd.mobile_placeholder')" class="form-control input-style"
                        maxlength="10" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                      >
                      <div class="error-feedback red-color fonttext-14" v-if="validate.mobile.$error">
                        {{ validateMessage }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <label for="" class="p-content">{{$t('addAd.businessTransfer_email')}}</label>
                      <input type="email" v-model="email" :placeholder="$t('addAd.email_placeholder')" class="form-control input-style">
                    </div>
                  </div>

                  <h6 class="pt-3 almarai-bold">{{$t('addAd.activity_Details')}}</h6>
                  <div class="row py-2">
                    <div class="col-12 col-md-6">
                      <label for="" class="p-content">
                        <span> ⁠{{$t('addAd.business_Activity')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <select class="form-select input-style" v-model="businessId">
                        <option :value="null">{{$t('addAd.chooseType_Business')}}</option>
                        <option v-for="(businessType, index) in businessList" :key="index" :value="businessType.id">
                          {{businessType.name}}
                        </option>
                      </select>
                      <div class="error-feedback red-color fonttext-14" v-if="validate.businessId.$error">
                        {{validateMessage }}
                      </div>
                    </div>
                    <div v-if="businessOther && businessOther.id == businessId" class="col-12 col-md-6">
                      <label for="" class="p-content">
                        <span> ⁠{{$t('addAd.businessName')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="businessName" class="form-control input-style" />
                    </div>
                    <div class="col-12 col-md-6">
                      <label for="" class="p-content">{{$t('addAd.Project_Area')}}</label>
                      <input type="text" v-model="Project_Area" :placeholder="$t('addAd.area_placeholder')" class="form-control input-style"
                        maxlength="10" @input="Project_Area = Project_Area.replace(/[^0-9]/g, '')"
                      >
                    </div>
                  </div>
                  
                  <div class="row pt-2">
                    <div class="col">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.description')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <textarea rows="3" v-model="description" class="form-control br-radius-16"></textarea>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.description.$error">
                      {{validateMessage }}
                    </div>
                  </div>

                  <div class="row pt-3">
                    <div class="col-6 col-md-6">
                      <label for="" class="p-content">{{$t('addAd.annual_Rental')}}</label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.annual_placeholder')" 
                        v-model="rentPrice" maxlength="10" @input="rentPrice = rentPrice.replace(/[^0-9]/g, '')"
                      >
                    </div>
                    <div class="col-6 col-md-6">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.Remaining')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <!-- <input type="text" class="form-control input-style" :placeholder="$t('addAd.Remaining_placeholder')" 
                        v-model="ageId" @input="ageId = ageId.replace(/[^0-9]/g, '')"
                      > -->
                      <select class="form-select input-style" v-model="ageId" aria-label="Default select example">
                        <option :value="null">{{$t('addAd.Remaining_placeholder')}}</option>
                        <option  v-for="(val, projectIndex) in agesList" :key="projectIndex" :value="val.id">
                          {{val.name}}
                        </option>
                      </select>
                      <div class="error-feedback red-color fonttext-14" v-if="validate.ageId.$error">
                        {{validateMessage }}
                      </div>
                    </div>
                  </div>

                  <div class="row pt-3">
                    <div class="col-12 col-md-6">
                      <label class="p-content">
                        <span>{{$t('addAd.amount')}}</span>
                      </label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.amount_placeholder')"
                        v-model="price" maxlength="10" @input="price = price.replace(/[^0-9]/g, '')"
                      >
                    </div>

                    <div class="col-12 col-md-6">
                      <label for="" class="p-content">{{$t('addAd.workersCount')}}</label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.workers_placeholder')" v-model="workersCount" 
                        maxlength="10" @input="workersCount = workersCount.replace(/[^0-9]/g, '')"
                      >
                    </div>
                  </div>

                  <div class="row pt-3">
                    <div class="col-12 col-md-12">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.transfer_Reason')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <select class="form-select input-style" v-model="reasonId">
                        <option :value="null">{{$t('addAd.reason_placeholder')}}</option>
                        <option v-for="(reason, key) in reasonsList" :key="key" :value="reason.id">
                          {{reason.name}}
                        </option>
                      </select>
                      <div class="error-feedback red-color fonttext-14" v-if="validate.reasonId.$error">
                        {{validateMessage }}
                      </div>
                    </div>
                  </div>
                  
                  

                  <h6 class="pt-3 almarai-bold">{{$t('addAd.location')}}</h6>
                  <div class="row pt-2">
                    <div class="col-12 col-md-4">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.area')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <Select2
                        :placeholder="$t('home.ft_5')"
                        class="mouse-hand form-select input-style pe-5 fonttext-14 style-form-select"
                        :modelValue="region"
                        v-model="region"
                        :options="regionsObj"
                        @select="citiesList()"
                      ></Select2>
                      <!-- <select @change="citiesList" class="form-select input-style" v-model="region">
                        <option :value="null">{{$t('addAd.A_placeholder')}}</option>
                        <option v-for="(regions, regionKey) in regionsList" :key="regionKey" :value="regions.id">
                          {{regions.name}}
                        </option>
                      </select> -->
                      <div class="error-feedback red-color fonttext-14" v-if="validate.region.$error">
                        {{validateMessage }}
                      </div>
                    </div>
                    <div class="col-6 col-md-4">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.city')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <Select2
                        :placeholder="$t('home.ft_6')"
                        class="mouse-hand form-select input-style pe-5 fonttext-14 style-form-select"
                        :modelValue="city"
                        v-model="city"
                        @click="checkRegions"
                        :options="cityObj"
                        @select="neighborhoodList()"
                      ></Select2>
                      <!-- <select @change="neighborhoodList" @click.prevent="checkRegions" class="form-select input-style" v-model="city">
                        <option :value="null">{{$t('addAd.city_placeholder')}}</option>
                        <option v-for="(city, citiesIndex) in cities" :key="citiesIndex" :value="city.id">
                          {{city.name}}
                        </option>
                      </select> -->
                      <div class="error-feedback red-color fonttext-14" v-if="validate.city.$error">
                        {{validateMessage }}
                      </div>
                    </div>
                    <div class="col-6 col-md-4">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.neighborhood')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <Select2
                        class="mouse-hand form-select input-style pe-5 fonttext-14 style-form-select"
                        :modelValue="neighborhood"
                        v-model="neighborhood"
                        @click="checkNeighborhoods"
                        @select="setmarker"
                        :placeholder="$t('home.ft_7')"
                        :options="itemsOb"
                      ></Select2>
                      <!-- <select class="form-select input-style" v-model="neighborhood" @click.prevent="checkNeighborhoods">
                        <option :value="null">{{$t('addAd.neighborhood_placeholder')}}</option>
                        <option v-for="(row, neighborhoodIndex) in items" :key="neighborhoodIndex" :value="row.id">
                          {{row.name}}
                        </option>
                      </select> -->
                      <div class="error-feedback red-color fonttext-14" v-if="validate.neighborhood.$error">
                        {{validateMessage }}
                      </div>
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <h6 class="p-content py-2">{{$t('addAd.location_Map')}}</h6>
                      <div ref="myMap" style="width: 100%; height: 320px;"></div>
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col-6 col-md-6 pb-2">
                      <label class="p-content" for="">
                        {{$t('addAd.title_70')}}
                        <span class="stars">*</span>
                      </label>
                      <input type="number" class="form-control input-style" v-model="longitude">
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.longitude.$error">
                      {{validateMessage }}
                    </div>
                    <div class="col-6 col-md-6 pb-2">
                      <label class="p-content" for="">
                        {{$t('addAd.title_71')}}
                        <span class="stars">*</span>
                      </label>
                      <input type="number" class="form-control input-style" v-model="latitude">
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="validate.latitude.$error">
                      {{validateMessage }}
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col">
                      <label for="" class="p-content">
                        <span>{{$t('addAd.view')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <select class="form-select input-style" v-model="frontId">
                        <option :value="null">{{$t('addAd.view_placeholder')}}</option>
                        <option v-for="(front, iden) in frontsList" :key="iden" :value="front.id">
                          {{front.name}}
                        </option>
                      </select>
                      <div class="error-feedback red-color fonttext-14" v-if="validate.frontId.$error">
                        {{validateMessage }}
                      </div>
                    </div>
                  </div>

                  <h6 class="pt-3 almarai-bold">{{$t('addAd.assets')}}</h6>
                  <div class="row">
                    <div class="col">
                      <label for="" class="p-content py-2">{{$t('addAd.assetsLabel')}}</label>
                      <textarea class="form-control br-radius-16" v-model="assetsList_text" :placeholder="$t('addAd.asset_placeholder')" rows="3"></textarea>
                    </div>
                  </div>

                  <div class="row pt-2 justify-content-center">
                    <div class="col-12 col-md-6">
                      <label for="" class="p-content py-2">
                        <span>{{$t('addAd.fixed_Asset')}}</span>
                      </label>
                      <select class="form-select input-style" v-model="assetId">
                        <option :value="null">{{$t('addAd.fixed_Asset_holder')}}</option>
                        <option v-for="(asset, inde) in assetsList" :key="inde" :value="asset.id">
                          {{asset.name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-12 col-md-6">
                      <label for="" class="p-content py-2">⁠{{$t('addAd.financial_Obigations')}}</label>
                      <select class="form-select input-style" v-model="hasDebts">
                        <option :value="false">{{$t('addAd.no')}}</option>
                        <option :value="true">{{$t('addAd.yes')}}</option>
                      </select>
                    </div>
                  </div>
                  
                  <div class="row" v-if="hasDebts">
                    <div class="col">
                      <label for="" class="p-content py-2">{{$t('addAd.Explain')}}</label>
                      <textarea rows="3" v-model="debtsList" class="form-control br-radius-16" :placeholder="$t('addAd.Explain')"></textarea>
                    </div>
                  </div>

                  <h6 class="pt-3 almarai-bold">{{$t('addAd.projects_Strengths')}}</h6>
                  <div class="row pt-2">
                    <div class="col-auto p-3" v-for="(row, strengthKey) in strengthsList" :key="strengthKey">
                      <div class="form-check">
                        <input class="form-check-input radio-style" type="checkbox" v-model="strengths" :value="row.id" :id="`streng_${row.id}`">
                        <label class="form-check-label mouse-hand" :for="`streng_${row.id}`">
                          {{row.name}}
                        </label>
                      </div>
                    </div>
                    
                  </div>

                  <h6 class="pt-3 almarai-bold">{{$t('addAd.projects_Weaknesses')}} </h6>
                  <div class="row pt-2">
                    <div class="col-auto p-3" v-for="(item, weaknessesIndex) in weaknessList" :key="weaknessesIndex">
                      <div class="form-check">
                        <label class="form-check-label mouse-hand" :for="`weak_${item.id}`">
                          <input class="form-check-input radio-style" v-model="weaknesses" type="checkbox" :value="item.id" :id="`weak_${item.id}`">
                          {{item.name}}
                        </label>
                      </div>
                    </div>
                  </div>

                  <h6 class="pt-3 almarai-bold">{{$t('addAd.additional_Notes')}}</h6>
                  <div class="row pt-2">
                    <div class="col-6 col-md-6">
                      <label class="p-content pb-2">
                        <span>{{$t('addAd.project_Age')}}</span>
                        <span class="stars">*</span>
                      </label>
                      <select class="form-select input-style" v-model="projectAgeId" aria-label="Default select example">
                        <option :value="null">{{$t('addAd.project_Age_holder')}}</option>
                        <option  v-for="(val, projectIndex) in agesList" :key="projectIndex" :value="val.id">
                          {{val.name}}
                        </option>
                      </select>
                      <div class="error-feedback red-color fonttext-14" v-if="validate.projectAgeId.$error">
                        {{validateMessage }}
                      </div>
                    </div>
                    <div class="col-6 col-md-6">
                      <label class="p-content py-2">{{$t('addAd.officesCount')}}</label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.officesCount_holder')"
                        v-model="officesCount" maxlength="10" @input="officesCount = officesCount.replace(/[^0-9]/g, '')"
                      >
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col-6 col-md-6">
                      <label class="p-content py-2"> {{$t('addAd.roomsCount')}}</label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.roomsCount_holder')"
                        v-model="roomsCount" maxlength="10" @input="roomsCount = roomsCount.replace(/[^0-9]/g, '')"
                      >
                    </div>
                    <div class="col-6 col-md-6">
                      <label class="p-content py-2">{{$t('addAd.hallsCount')}}</label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.hallsCount_holder')"
                        v-model="hallsCount" maxlength="10" @input="hallsCount = hallsCount.replace(/[^0-9]/g, '')"
                      >
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col-6 col-md-3">
                      <label class="p-content py-2">{{$t('addAd.doorsCount')}}</label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.doorsCount_holder')"
                        v-model="doorsCount" maxlength="10" @input="doorsCount = doorsCount.replace(/[^0-9]/g, '')"
                      >
                    </div>
                    <div class="col-6 col-md-3">
                      <label class="p-content py-2">{{$t('addAd.bathroomsCount')}}</label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.bathroomsCount_holder')"
                        v-model="bathroomsCount" maxlength="10" @input="bathroomsCount = bathroomsCount.replace(/[^0-9]/g, '')"
                      >
                    </div>
                    <div class="col-6 col-md-3">
                      <label class="p-content py-2">{{$t('addAd.floorsCount')}} </label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.floorsCount_holder')"
                        v-model="floorsCount" maxlength="10" @input="floorsCount = floorsCount.replace(/[^0-9]/g, '')"
                      >
                    </div>
                    <div class="col-6 col-md-3">
                      <label class="p-content py-2">{{$t('addAd.parkingCount')}}</label>
                      <input type="text" class="form-control input-style" :placeholder="$t('addAd.parkingCount_holder')"
                        v-model="parkingCount" maxlength="10" @input="parkingCount = parkingCount.replace(/[^0-9]/g, '')"
                      >
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col">
                      <label class="p-content py-2">{{$t('addAd.notices')}}</label>
                      <!-- <input type="text" class="form-control input-style" > -->
                      <textarea rows="3"  v-model="notices" :placeholder="$t('addAd.notices_holder')" class="form-control br-radius-16"></textarea>
                    </div>
                  </div>

                  <div class="row pt-3">
                    <div class="col">
                      <label class="p-content py-2">⁠{{$t('addAd.uploadMedia')}}</label>
                      <input type="file" v-if="!mediaLoader" class="form-control input-style" @change="uploadMedia($event.target.files)" multiple> 
                      <!--begin mediaLoader-->
                      <div v-if="mediaLoader" class="text-center"><loader /></div>
                      <!--end mediaLoader-->
                      <div class="row">
                        <div class="col-auto my-2" v-for="(img, indx) in mediaList" :key="indx">
                          <div class="position-R" @click.prevent="deleteImg(img.id, indx)">
                            <i class="bi bi-trash delete-icon red-color mouse-hand"></i>
                          </div>
                          <img :src="MEDIA_URL+img.path" style="max-width: 160px;" alt="">
                        </div>
                      </div>
                      <!-- <div class="uploadFile">
                        <img src="/assets/images/icons/Featured icon.png"  alt=""> <br>
                        <label class="orange-color mouse-hand" for="upload" >انقر للتحميل</label> <span class="gray-53">أو السحب والإفلات</span> <br>
                        <span class="gray-53 fonttext-14">Pdf, Word (بحد أقصى  1 ميجا بايت )</span>
                      </div> -->
                    </div>
                  </div>

                  <div class="row py-3">
                    <div class="col">
                      <div class="card Free">
                        <div class="card-body p-2">
                          <div class="row">
                            <div class="col content-center text-center">
                              <span class="text-free">{{$t('addAd.Disclaimer')}} </span>
                              <div class="serviceText pt-2"> {{$t('addAd.service')}}<br>{{$t('addAd.service_2')}}</div>
                            </div>
                            <div class="col-auto img_Free">
                              <img src="assets/images/Frame-Free.png" class="freeLogo" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row pt-5 dierction">
                    <div class="col-auto mouse-hand content-center">
                      <router-link to="/propertiecreate">
                        <div class="btn btn-light padding-style almarai-bold">{{$t('addAd.button_Cancel')}}</div>
                      </router-link>
                    </div>
                    <div v-if="loaderExchange" class="text-center"><loader /></div>
                    <div v-else class="col-auto mouse-hand" @click.prevent="createExchanges">
                      <div class="btn-green">{{$t('addAd.button_submit_request')}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row" v-if="step == 3">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div><img src="/assets/images/tick-circle.png" class="width-48" alt=""></div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col text-center">
            <h4 class="almarai-bold">تم تقديم طلب التقبيل بنجاح</h4>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col text-center">
            <span class="p-content">ستتواصل معك خدمة العملاء خلال ٢٤ ساعة</span>
          </div>
        </div>

        <div class="row py-4 justify-content-center">
          <div class="col-11 col-md-5">
            <router-link to="/">
              <button class="login-btn rounded-pill form-control">{{$t('formSuccess.title_4')}}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>


    <div class="modal bg-modal" id="selectRegion" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('regionFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-green" @click="closePopup" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>

    <div class="modal bg-modal" id="selectNeighborhoods" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <img src="/assets/images/icons/Error.png" class="width-48" alt="">
              </div>
            </div>
            <div class="row justify-content-center pt-3">
              <div class="col text-center">
                <p class="mb-1 almarai-bold">{{$t('errorOccurred')}}</p>
                <h6 class="small-Font">{{$t('cityFirst')}}</h6>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-8 text-center mouse-hand text-white">
                <div class="btn-green" @click="exit" >{{$t('continuation')}}</div>
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- Nafath modal -->
    <button type="button" class="d-none" id="nafathBtnId" data-bs-toggle="modal" data-bs-target="#nafathModal">
      Launch demo modal
    </button>

    <!-- Modal -->
    <div class="modal fade modal-sm" id="nafathModal" tabindex="-1" aria-labelledby="nafathModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="nafathModalLabel">{{ $t('nafath.cardTitle') }}</h1>
            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          </div>
          <div class="modal-body">{{ $t('nafath.mustVerify') }}</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-bs-dismiss="modal" @click="goToNafath"><i class="fa-solid fa-house-circle-check"></i> {{$t('nafath.linkTitle')}}</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('nafath.notNow') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapGetters } from 'vuex';
export default {
  name: 'businessproject',

  setup(){
    return { validate: useVuelidate() }
  },

  data(){
    return{
      hasError: false,
      message: '',
      errorNumber: null,
      isLoading: true,
      name: '',
      mobile: '',
      email: '',
      businessId: null,
      Project_Area: null,
      description: '',
      rentPrice: null,
      remainingTerm: '',
      workersCount: null,
      region: null,
      city: null,
      neighborhood: null,
      longitude: '',
      latitude: '',
      frontId: null,
      assetId: null,
      ageId: null,
      reasonId: null,
      assetsList_text: '',
      hasDebts: false,
      debtsList: "",
      projectAgeId: null,
      officesCount: null,
      roomsCount: null,
      hallsCount: null,
      doorsCount: null,
      bathroomsCount: null,
      floorsCount: null,
      parkingCount: null,
      price: null,
      notices: "",
      mediaIds: [],
      strengths: [],
      weaknesses: [],
      businessList: [],
      frontsList: [],
      assetsList: [],
      reasonsList: [],
      agesList: [],
      strengthsList: [],
      weaknessList: [],
      regionsList: [],
      cities: [],
      items: [],
      mediaIds: [],
      mediaList: [],
      mediaLoader: false,
      loaderExchange: false,
      step: 1,
      userLang: 'ar',
      validateMessage: this.$t('validateMessage'),
      businessOther: null,
      businessName: null,
      regionsObj: [],
      cityObj: [],
      itemsOb: [],
    }
  },

  computed:{
    ...mapGetters(['MEDIA_URL', 'GET_USER_DATA']),
  },

  validations (){
    return {
      name: {required},
      mobile: {required},
      businessId: {required},
      description: {required},
      ageId: {required},
      reasonId: {required},
      region: {required},
      city: {required},
      neighborhood: {required},
      latitude: {required},
      longitude: {required},
      frontId: {required},
      projectAgeId: {required},
    }
  },

  methods:{
    async createExchanges(){
      this.hasError = false;
      const valid = await this.validate.$validate();
      if(!valid){
        window.scrollTo({top:0, behavior: 'smooth'});
        return false;
      }
      this.loaderExchange = true;

      let payload = {
        name: this.name,
        mobile: this.mobile,
        email: this.email,
        businessId: parseInt(this.businessId),
        area: parseInt(this.Project_Area),
        description: this.description,
        rentPrice: parseInt(this.rentPrice),
        ageId: parseInt(this.ageId),
        workersCount: parseInt(this.workersCount),
        reasonId: this.reasonId,
        regionId: this.region,
        cityId: this.city,
        neighborhoodId: this.neighborhood,
        latitude: this.latitude,
        longitude: this.longitude,
        frontId: this.frontId,
        assetsList: this.assetsList_text,
        assetId: this.assetId,
        hasDebts: this.hasDebts,
        debtsList: this.debtsList,
        projectAgeId: this.projectAgeId,
        officesCount: parseInt(this.officesCount),
        roomsCount: parseInt(this.roomsCount),
        hallsCount: parseInt(this.hallsCount),
        doorsCount: parseInt(this.doorsCount),
        bathroomsCount: parseInt(this.bathroomsCount),
        floorsCount: parseInt(this.floorsCount),
        parkingCount: parseInt(this.parkingCount),
        price: parseInt(this.price),
        notices: this.notices,
        strengths: this.strengths,
        mediaIds: this.mediaIds,
      };

      if(this.businessOther && this.businessOther.id == this.businessId){
        if(!this.businessName){
          this.loaderExchange = false;
          this.message = this.$t('addAd.businessNameRequired');
          this.hasError = true;
          window.scrollTo({ top:0, behavior:'smooth'});
          return false;
        }else{
          payload.businessName = this.businessName;
        }
      }

      this.$http.post("/api/exchanges/create", payload).then(res => {
        // console.log(res);
        this.step = 3;
        this.loaderExchange = false;
      }).catch(err => {
        // console.log(err);
        this.loaderExchange = false;
        [this.message, this.errorNumber] = this.$globalError(err,true);
        this.hasError = true;
        window.scrollTo({ top:0, behavior:'smooth'});
      })
    },

    nextStep(){
      // const modalBtn = document.getElementById('nafathBtnId');
      // if(this.GET_USER_DATA.nafathStatus != 'COMPLETED' && modalBtn){
      //   modalBtn.click();
      // }else{  
      //   }
      this.step = 2;
    },
    //function get Location user
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition (
          (position) => {
            this.longitude = position.coords.longitude;
            this.latitude = position.coords.latitude;
          },
          (err) => {
            // this.error = `Error: ${err.message}`;
            // this.getData();
          }
        );
      }else {
        // this.error = "Geolocation is not supported by this browser.";
        // this.getData();
      }
    },
    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.latitude) ? parseFloat(this.latitude) :24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753, 
        },
        zoom: 8,
      });
      
      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.latitude)? parseFloat(this.latitude) : 24.7136, 
          lng: (this.longitude) ? parseFloat(this.longitude) : 46.6753 
        },
        map: this.map,
        draggable: true, // Allow dragging the marker
      });

      // Update lat/lng when marker is moved
      this.marker.addListener("dragend", () => {
        const pos = this.marker.getPosition();
        this.latitude = pos.lat();
        this.longitude = pos.lng();
        this.cityByLatFN();
      });

      // Click on the map to set a new marker position
      this.map.addListener("click", (event) => {
        this.latitude = event.latLng.lat();
        this.longitude = event.latLng.lng();
        this.marker.setPosition(event.latLng);
        this.cityByLatFN();
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },

    getDataInitial(){
      this.$http.get('/api/exchanges/init').then(res => {
        // console.log(res);
        this.businessList = res.data.businessList;
        this.frontsList = res.data.frontsList;
        this.assetsList = res.data.assetsList;
        this.reasonsList = res.data.reasonsList;
        this.regionsList = res.data.regionsList;
        this.agesList = res.data.agesList;
        this.strengthsList = res.data.strengthsList;
        this.weaknessList = res.data.weaknessList;
        this.businessOther = res.data.businessOther ?? null;
        let regionOption = [];
        for (let R = 0; R < this.regionsList.length; R++) {
          regionOption.push({
            id: this.regionsList[R].id,
            text: this.regionsList[R].name,
          });
        }
        this.regionsObj = regionOption;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
      });
    },

    citiesList(){
      this.searchError = false;
      this.cities = [];
      if(this.region){
        this.$http.get("/api/cities/list?regionId="+this.region).then(res => {
          // console.log(res);
          this.cities = res.data.cities;
          let cityOptions = [];
        for (let i = 0; i < this.cities.length; i++) {
          cityOptions.push({ id: this.cities[i].id, text: this.cities[i].name });
        }
        this.cityObj = cityOptions;
        this.loader = false
        }).catch(err => {
          // console.log(err);
          [this.message, this.errorNumber] = this.$globalError(err,true);
          this.searchError = true;
          this.loader = false
        });
      }
    },

    neighborhoodList(){
      this.items = [];
      if(this.city){
        this.$http.get("/api/neighborhoods/list?cityId="+this.city).then(res => {
          // console.log(res);
          this.items = res.data.neighborhoods;
          let optionsArray = [];
        for (let i = 0; i < this.items.length; i++) {
          optionsArray.push({
            id: this.items[i].id,
            text: this.items[i].name,
          });
        }
        this.itemsOb = optionsArray;
        }).catch(err => {
          // console.log( err);
          this.loading = false;
          [this.message, this.errorNumber] = this.$globalError(err,true);
          this.searchError = true;
        });
      }
    },

    async uploadMedia(files){
      this.mediaLoader = true;
      for(let i=0; i<files.length; i++){
        const formData = new FormData();
        formData.append('file', files[i]);
        try {
          const mediaFile = await this.$http.post("/api/exchanges/media/upload",formData);
          if(mediaFile) {
            this.mediaIds.push(mediaFile.data.mediaId);
            this.mediaList.push({
              id: mediaFile.data.mediaId,
              path: mediaFile.data.filePath,
            })
          }
        }catch (err){
          [this.message , this.errorNumber] = this.$globalError(err ,true);
          this.hasError = true;
          window.scroll(0,0);
          this.mediaLoader = false;
        }finally{
          this.mediaLoader = false;
        }
      }
    },

    deleteImg(id, indx){
      swal({
        title: this.$t('image_Title'),
        // text: "You will not be able to recover this imaginary file!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: this.$t('confirmButtonText'),
        cancelButtonText: this.$t('cancelButtonText'),
        closeOnConfirm: false
      },()=> this.deleteMedia(id, indx));
    },
    deleteMedia(id, indx){
      this.$http.delete("/api/exchanges/media/delete/"+id).then(res => {
        this.mediaList.splice(indx, 1);
        this.mediaIds.splice(indx, 1);
        swal( this.$t('success_Message'));
      })
    },

    charsOnly(e) {
      // keep only Arabic letters, Latin letters, and spaces
      // requires modern JS regex support for Unicode property escapes
      const char = e.key;
      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
    },

    cityByLatFN(){
      this.$http.post('/api/cities/cityByLat',{
        longitude: this.longitude,
        latitude: this.latitude,
      }).then(res => {
        // console.log(res);
        if(res.data.region){
          this.region = res.data.region.id;
          this.citiesList();
        }
        if(res.data.city){
          this.city = res.data.city.id;
          this.neighborhoodList();
        }
        if(res.data.neighborhood)
          this.neighborhood = res.data.neighborhood.id;
      }).catch(err => {
        console.log(err);
      })
    },

    checkRegions(){
      if(!this.region){
        document.getElementById('selectRegion').style.display ='block';
      }
    },

    checkNeighborhoods(){
      if(!this.city){
        document.getElementById('selectNeighborhoods').style.display ='block';
      }
    },

    closePopup(){
      document.getElementById('selectRegion').style.display ='none';
    },
    exit(){
      document.getElementById('selectNeighborhoods').style.display ='none';
    },
    goToNafath(){
      this.$router.push('/nafath');
    },

    setmarker(){
      this.items.map(row => {
        if(row.id == this.neighborhood){
          const newPosition = {
            lat: parseFloat(row.latitude),
            lng: parseFloat(row.longitude),
          };

          // Move marker
          this.marker.setPosition(newPosition);

          // Move map center
          this.map.setCenter(newPosition);
          // this.marker.setPosition({
          //   lat: parseFloat(row.latitude),
          //   lng: parseFloat(row.longitude),
          // });
        }
      })
    }

  },
  created(){
    this.getDataInitial();
    this.getLocation();
    this.initialGoogleMap();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior: 'smooth'})
  }
}
</script>